import { reportCompoent, ReportDomTag, destoryReportIOInstance } from './monitor'
import { getRenderMenuId } from 'public/utils'
import moment from 'moment'

export default {
  mounted() {
    try {
      const tag = (this.$options && this.$options.name) || (this.$vnode && this.$vnode.tag)
      const menu_id = getRenderMenuId(this)
      // 不存在菜单就不上报。虚拟菜单就是错误的场景。会使用上一次的菜单
      if (menu_id) {
        reportCompoent({
          reportName: this.$options.reportName,
          tag,
          dom: this.$el,
          menuId: menu_id,
          payload: {
            menu_id,
            url: location.href,
            report_date: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss'),
          }
        })
      }
    } catch (error) {
      console.info('【组件上报异常】', error)
    }
  },
  destroyed () {
    if (this.$el && this.$el[ReportDomTag]) {
      const el = this.$el instanceof HTMLElement ? this.$el : null
      if (el && el[ReportDomTag]) {
        el[ReportDomTag].unobserve(el)
        el[ReportDomTag] = null
      }
    }
    destoryReportIOInstance()
  }
}



// WEBPACK FOOTER //
// ./src/public/mixins/component-report/index.js